module.exports = __webpack_public_path__ + "static/media/lazer.fc3bdade.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/categoria-interesse/lazer.jpg
// module id = 2020
// module chunks = 14